import { render, staticRenderFns } from "./surrenderStatus.vue?vue&type=template&id=2a1a1b80&scoped=true&"
import script from "./surrenderStatus.vue?vue&type=script&lang=js&"
export * from "./surrenderStatus.vue?vue&type=script&lang=js&"
import style0 from "./surrenderStatus.vue?vue&type=style&index=0&id=2a1a1b80&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1a1b80",
  null
  
)

export default component.exports